import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

import { BingoConfig, BingoConfigProviderService } from '@frontend/bingo/frontend-lib/core';

@Injectable({
    providedIn: 'root',
})
export class BrandRoomDesignService implements CanActivate {
    constructor(private configProviderService: BingoConfigProviderService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const clienConfig: BingoConfig = this.configProviderService.provideBingoConfig();
        const brand = route.data['brand'] as string[];
        if (clienConfig.brandID == brand[0]) {
            return true;
        }
        return false;
    }
}
